const characteristics = {
	activation: {
		uuid: '1fb91a52-0000-49da-a31a-0401cc94acc4'
	},
	ssid: {
		uuid: 'eac0d61a-0000-e3f3-baeb-38ddd48474eb'
	},
	password: {
		uuid: 'eac0d61a-0001-e3f3-baeb-38ddd48474eb'
	},
	isFound: {
		uuid: 'c01ff0ad-0000-43b9-a6ef-cf71ba1eb665'
	}
};

export default {

	rssiInterval: null,

	startMeasuringRssi(deviceId, callback, errorCallback) {
		if(typeof ble === 'undefined') return;

		this.stopMeasuringRssi();
		this.rssiInterval = setInterval(() => {
			ble.readRSSI(deviceId,
				rssi => callback(rssi),
				err => {
					errorCallback()
					// clearInterval(this.rssiInterval)
				} // Out of range
			);
		}, 1000);
	},

	stopMeasuringRssi() {
		clearInterval(this.rssiInterval);
	},

	disconnect() {
		if(typeof ble === 'undefined') return;

		this.stopMeasuringRssi();
		ble.disconnect();
	},

	find(deviceId){
		return new Promise((resolve, reject) => {

			if(typeof ble === 'undefined') reject('Bluetooth not available');

			let isFound = false;

			console.log('BLE Scan');


			ble.scan([], 10, (advertisement) => {
				// ble.startScan([], (advertisement) => {

				if(!advertisement.name || !advertisement.id) return;

				if(advertisement.advertising && advertisement.advertising.kCBAdvDataLocalName)
					advertisement.name = advertisement.advertising.kCBAdvDataLocalName;

				if(advertisement.name.substr(-6) == deviceId.substr(-6)) {
					isFound = true;
					ble.stopScan();
					console.log('BLE Device Found');
					resolve(advertisement);
				}
			},
			(e) => {

				if(e.toString() == 'Location Services are disabled') {

					cordova.plugins.locationAccuracy.canRequest(function(canRequest){
						if(canRequest){
							cordova.plugins.locationAccuracy.request(function (success){
								console.log("Successfully requested accuracy: "+success.message);
							}, function (error){
								console.error("Accuracy request failed: error code="+error.code+"; error message="+error.message);
								if(error.code !== cordova.plugins.locationAccuracy.ERROR_USER_DISAGREED){
									if(window.confirm("Failed to automatically set Location Mode. Would you like to switch to the Location Settings page and do this manually?")){
										cordova.plugins.diagnostic.switchToLocationSettings();
									}
								}
							}, cordova.plugins.locationAccuracy.REQUEST_PRIORITY_LOW_POWER);
						}
					});
				}

				console.log('BLE Device not Found');
				console.log('Error:', e);

				if(!isFound) reject(`Device: ${deviceId} not found`);
			});

			setTimeout(() => {
				if(!isFound) reject(`Device: ${deviceId} not found`);
			}, 11000);

		});
	},

	isConnected(id) {
		return new Promise((resolve, reject) => {
			ble.isConnected(
				id,
				() => resolve(true),
				() => resolve(false),
			);
		});
	},

	bondedDevices() {
		return new Promise((resolve, reject) => {
			ble.bondedDevices(
				devices => resolve(devices),
				error => reject(error),
			);
		});
	},

	connect(id) {
		return new Promise((resolve, reject) => {
			ble.connect(
				id,
				device => resolve(device),
				err => reject(err)
			);
		});
	},

	validateDevice() {
		let requiredCharacteristics = Object.keys(characteristics)
			.reduce((arr, key) => [...arr, characteristics[key]], []);

		requiredCharacteristics = requiredCharacteristics.filter(characteristic => {
			return this.getCharacteristic(characteristic.uuid) === undefined;
		});

		return (requiredCharacteristics.length === 0);
	},

}
